/**
 * @generated SignedSource<<9a68fd09ad8c9dd0e5a0ad8b8c701750>>
 * @relayHash 3f092e22e11bcfe2dfda2d88d2170724
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dbf6dfd8f9d8b18c409442497a8cffe3158c9616c5c48de1ba0c626b858104bd

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ServicesAndSkillsRowLiveRoutingTableQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type ServicesAndSkillsRowLiveRoutingTableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ServicesAndSkillsRow">;
};
export type ServicesAndSkillsRowLiveRoutingTableQuery = {
  response: ServicesAndSkillsRowLiveRoutingTableQuery$data;
  variables: ServicesAndSkillsRowLiveRoutingTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "ServicesAndSkillsRow"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentWorkspaceSmartRoutingConfig",
        "kind": "LinkedField",
        "name": "agentWorkspace_routingConfig",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "enabled"
          },
          {
            "kind": "ScalarField",
            "name": "serviceFieldId"
          },
          {
            "kind": "ScalarField",
            "name": "serviceFieldName"
          },
          {
            "kind": "ScalarField",
            "name": "serviceFieldType"
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentWorkspaceLiveRoutingTable",
        "kind": "LinkedField",
        "name": "agentWorkspace_liveRoutingTable",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentWorkspaceRoutingTableEntry",
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "serviceId"
              },
              {
                "kind": "ScalarField",
                "name": "serviceName"
              },
              {
                "concreteType": "TeamV2",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "smallAvatarImageUrl"
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "concreteType": "AgentWorkspaceSkill",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dbf6dfd8f9d8b18c409442497a8cffe3158c9616c5c48de1ba0c626b858104bd",
    "metadata": {},
    "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5fc2d85f557000c56c525177a8485258";

export default node;
